import React, { useState, useEffect, useCallback, useRef } from "react";
import Button from "components/shared/Button";
import loader from "assets/loader.gif";
import { Formik, Form, FormikHelpers, ErrorMessage } from "formik";
import FormFieldChange from "components/shared/FormFieldChange";
import axios from "axios";
import { IStep } from "types";
import Frame from "components/shared/Frame";
import * as Yup from "yup";
import { pagination } from "utils/FuzzySearch";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import { USER_ROLES } from "utils/UIProvider";
import { api } from "../../constants";

const SchoolSearch: React.FC<IStep> = ({ onNext, onBack, value }: any) => {
  const formikRef = useRef<any>(null);

  useEffect(() => {
    const debouncedSubmit = debounce(() => {
      if (formikRef.current) {
        formikRef.current.handleSubmit();
      }
    }, 300); // Adjust the delay as needed

    return () => {
      debouncedSubmit.cancel();
    };
  }, []);

  const handleSchoolSubmit = async () => {
    setIsSchoolScreationLoading(true);
    const { data } = await axios.post(api, {
      password: password,
      s_id: selectedSchool?.ID || "",
      user: {
        email: email,
        username: generateRandomString(6),
        school_name: selectedSchool?.["Name of School"],
        role: USER_ROLES.SCHOOL,
      },
      cmd: "ModHandle.signUpIndianPortal",
    });

    if (data.state === 200) {
      toast.success("User created successfully");
      onNext({ id: data.id });
    } else if (data.state === 400) {
    } else if (data.error) {
      toast.error(data.error);
    }

    setIsSchoolScreationLoading(false);
  };

  const [loading, setLoading] = useState<boolean>(false);
  // const [searchResultScreen, setSearchResultScreen] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [isSchoolScreationLoading, setIsSchoolScreationLoading] =
    useState(false);

  const [formData, setFormData] = useState({
    name: "",
    id: "",
    state: "",
    district: "",
  });

  const [schools, setSchools] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedSchool, setSelectedSchool] = useState<any>(null);
  const [screen, setScreen] = useState("search");

  const init = {
    email: "",
    password: "",
  };

  const handleSearchSchool = async (value: any, actions: any) => {
    setLoading(true);

    setFormData(value);
    console.log(value.name);
    if (value.name === "") {
      setSchools([]);
    } else {
      try {
        const results = await axios.get(
          `${
            value.state
              ? `https://teacherdbbackend.woogiu.com/bangalore/schools?type=byDistrict&district=${value.district}&name=${value.name}`
              : value.district
              ? `https://teacherdbbackend.woogiu.com/bangalore/schools?type=byDistrict&district=${value.district}&name=${value.name}`
              : "https://teacherdbbackend.woogiu.com/bangalore/schools"
          }`
        );

        if (results.status === 200) {
          setSchools(results.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    setLoading(false);
  };

  function generateRandomString(length: number) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const handleBack = () => {
    if (screen === "search") return onBack();
    if (screen === "add") return setScreen("search");
  };

  // const backward = () => {
  //   if (pageNo > 1) setPageNo((page) => page - 1);
  // };

  const paginated = pagination(schools.length, pageNo, 2);

  // const forward = () => {
  //   if (pageNo + 1 < paginated.last_page) setPageNo((page) => page + 1);
  // };

  const validationSchema = Yup.object().shape({
    state: Yup.string().required("State is required"),
    district: Yup.string().required("District is required"),
    name: Yup.string().when(["state", "district"], {
      is: (state: string, district: string) => state && district,
      then: Yup.string().required("School Name is required"),
      otherwise: Yup.string(),
    }),
  });

  return (
    <Frame
      title="Let's create your school account"
      onBackButtonClick={handleBack}
    >
      {screen === "search" && (
        <div className="relative">
          <Formik
            initialValues={formData}
            onSubmit={handleSearchSchool}
            validationSchema={validationSchema}
            innerRef={formikRef}
          >
            {({ handleSubmit, setFieldValue }) => (
              <div className="relative">
                <Form>
                  <div className="d-flex">
                    <div className="row__state">
                      <div className="state">
                        <FormFieldChange
                          name="state"
                          placeholder="State"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setFieldValue("state", e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <FormFieldChange
                        name="district"
                        placeholder="District"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setFieldValue("district", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <FormFieldChange
                        name="name"
                        placeholder="School Name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setFieldValue("name", e.target.value);

                          if (e.target.value === "") {
                            setSchools([]);
                          }
                          debounce(handleSubmit, 300)();
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="find__school__btn">
                      {/* <Button
                        value="Search"
                        btnType="green"
                        onClick={handleSubmit}
                      /> */}
                    </div>
                  </div>
                </Form>
              </div>
            )}
          </Formik>
          <div className="school-results absolute top-[230px] right-[10px] w-[100%]">
            <div className="flex flex-row justify-center items-center">
              <div className="school-list">
                {schools
                  .slice(paginated.from - 1, paginated.to)
                  .map((school: any, index) => (
                    <div
                      onClick={() => {
                        setSelectedSchool(school);
                        setScreen("add");
                      }}
                      key={`school.State${index}`}
                      className="school"
                    >
                      <h6 style={{ marginBottom: 0 }}>
                        {school?.["Name of School"]}
                      </h6>
                      <div className="d-flex justify-center">
                        <p>{school?.District}</p>&nbsp; <p>{school?.State}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {screen === "add" && (
        <Formik
          validationSchema={validationSchema}
          initialValues={init}
          onSubmit={handleSchoolSubmit}
        >
          {({ handleSubmit, setFieldValue }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <FormFieldChange
                    name="email"
                    placeholder="Email"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setFieldValue("email", e.target.value);
                      setEmail(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <FormFieldChange
                    name="password"
                    type="password"
                    placeholder="Password"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setFieldValue("password", e.target.value);
                      setPassword(e.target.value);
                    }}
                  />
                </div>
              </div>

              {isSchoolScreationLoading ? (
                <div className="loader flex flex-row justify-center items-center">
                  <img className="w-28" src={loader} alt="loader" />
                </div>
              ) : (
                <Button
                  style={{ margin: "auto" }}
                  value="submit"
                  onClick={() => {
                    handleSchoolSubmit();
                  }}
                />
              )}
            </Form>
          )}
        </Formik>
      )}
    </Frame>
  );
};

export default SchoolSearch;
